export const POS_KBN = {
  JISHA: 1,
  TASHA: 2,
  SIGMANET: 3,
  AUTOSERVER: 4,
  IAUC: 5,
  JU_TRADE: 6,
  OTHER: 9,
}

export const POS_KBN_LABELS = {
  [POS_KBN.JISHA]: '自社名義',
  [POS_KBN.TASHA]: '他社名義',
  [POS_KBN.SIGMANET]: 'シグマネット',
  [POS_KBN.AUTOSERVER]: 'オートサーバー',
  [POS_KBN.IAUC]: 'アイオーク',
  [POS_KBN.JU_TRADE]: 'JUトレード',
  [POS_KBN.OTHER]: 'その他代行業者',
}



// WEBPACK FOOTER //
// ./src/constants/posKbn.js